import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import axios from "axios";
import { config } from "../../App";
import moment from "moment";

const BirthdaySlider = () => {

  const token = sessionStorage.getItem("token");

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500, // 2.5 sec
    pauseOnHover: true   // hover pe ruk jayega (optional)
  };

  const [dobData, setDobData] = useState([]);

  const currentDate = new Date();

  const getDobDetailsData = async () => {
    try {
      const response = await axios.get(
        `${config.endpoint}/Home/getdobdetail?currentDate=${moment(currentDate, "DD/MMM/YYYY").format("DD/MM/YYYY")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      // console.log("profileData", response)
      if (response.data.status === true) {
        setDobData(response.data.Data);
      } else {
        setDobData([]);
      }

    } catch (error) {
      console.error("failed:", error);
    }
  }

  useEffect(() => {
    getDobDetailsData();
  }, [])

  return (
    <div className="birthday-card">

      <h3>Birthday</h3>

      <Slider {...settings}>

        {dobData?.map((item, index) => (
          <div className="birthday-item" key={index}>
            <img src={item.ProfilePicture !== null && item.ProfilePicture !== "" ? item.ProfilePicture : "/images/blank-profile.png"} alt={item.FullName} />
            <h4>{item.FullName} - {item.id}</h4>
            <p>{item.RoleDesignation}</p>
            <span>{item.Location}</span>
          </div>
        ))}

      </Slider>

    </div>
  );
};

export default BirthdaySlider;